import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'preloader',
    template: '#preloader'
})

export default class OrdersList extends Vue {
    // define prop
    @Prop({})
    itemsOnPage: number;

    // method
}